import { useDataStore, useFilterStore } from "@/stores";
import clsx from "clsx";
import { useEffect } from "react";

const SoftwareButton = () => {
    const software = useDataStore((state) => state.software);
    const activeVersion = useFilterStore((state) => state.activeVersion);
    const activeSoftware = useFilterStore((state) => state.activeSoftware);

    useEffect(() => {
        if (activeVersion && software[activeVersion]) {
            const activeSoftware = software[activeVersion].filter((x) => x.active && !x.isIfc);

            for (const item of activeSoftware) {
                document.documentElement.style.setProperty(`--color-software-${item.id}`, item.color ?? "#05b692");

                let softwareStyle = document.getElementById(`style-software-${item.id}`);
                if (softwareStyle) document.getElementsByTagName("head")[0].removeChild(softwareStyle);

                softwareStyle = document.createElement("style");
                softwareStyle.id = `style-software-${item.id}`;
                softwareStyle.innerHTML = `
                    .software-${item.id} {
                        background-color: color-mix(in oklab, var(--color-software-${item.id}) 10%, transparent);
                        color: var(--color-software-${item.id});
                        &:is(:where(.group):has(*:checked) *) {
                            background-color: var(--color-software-${item.id});
                            color: white;
                        }
                    }

                    .software-${item.id}:hover {
                        background-color: color-mix(in oklab, var(--color-software-${item.id}) 90%, transparent);
                        color: white;
                    }

                    .software-${item.id}-selector {
                        border-color: rgba(0, 0, 0, 0.25);
                    }

                    .software-${item.id}-selector:hover {
                        border-color: rgba(0, 0, 0, 0.25);
                    }

                    .software-${item.id}-selected {
                        background-color: var(--color-software-${item.id});
                    }

                    ${
                        item.invert &&
                        `.software-${item.id} img {
                        &:is(:where(.group):has(*:checked) *) {
                            filter: invert(1);
                        }
                    }
                    .software-${item.id}:hover img {
                        filter: invert(1);
                    }`
                    }
                `;
                document.getElementsByTagName("head")[0].appendChild(softwareStyle);
            }
        }
    }, [software, activeVersion]);

    if (!software[activeVersion!]) return null;

    const button = software[activeVersion!].find((x) => x.id === activeSoftware);
    if (!button) return null;

    return activeSoftware ? (
        <div
            className={clsx([
                "flex flex-wrap rounded-md text-base font-medium items-center",
                "min-h-[48px] gap-3 px-4 py-0",
                `software-${button.id}`,
                "pointer-events-none",
            ])}
        >
            {button.icon && (
                <div className="flex-shrink-0">
                    <img src={button.icon} alt={button.name} className={clsx(["h-[30px] w-auto"])} />
                </div>
            )}
            {button.name}
        </div>
    ) : null;
};

export default SoftwareButton;
